const MAX_IN_FLIGHT = 2;

const LIMITS = {
  english: 16,
  spanish: 16,
};

const cache = new Map();
const queue = [];
let activeCount = 0;

function normalizeEdition(edition) {
  return edition === "spanish" ? "spanish" : "english";
}

function keyFor(edition, page) {
  return `${normalizeEdition(edition)}:${page}`;
}

function isAllowedPage(edition, page) {
  const normalizedEdition = normalizeEdition(edition);
  return Number.isInteger(page) && page >= 1 && page <= LIMITS[normalizedEdition];
}

function enqueue(edition, page) {
  const normalizedEdition = normalizeEdition(edition);

  if (!isAllowedPage(normalizedEdition, page)) {
    return;
  }

  const key = keyFor(normalizedEdition, page);
  const existing = cache.get(key);

  if (
    existing &&
    (existing.status === "loading" ||
      existing.status === "ready" ||
      existing.status === "queued")
  ) {
    return;
  }

  cache.set(key, {
    status: "queued",
    url: null,
    error: null,
  });

  queue.push({
    edition: normalizedEdition,
    page,
    key,
  });

  pump();
}

function pump() {
  while (activeCount < MAX_IN_FLIGHT && queue.length > 0) {
    const job = queue.shift();

    const current = cache.get(job.key);

    if (!current || current.status !== "queued") {
      continue;
    }

    activeCount += 1;

    cache.set(job.key, {
      status: "loading",
      url: null,
      error: null,
    });

    fetch(
      `/api/preview/page/${job.page}.png?edition=${job.edition}`,
      {
        method: "GET",
        credentials: "same-origin",
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `Preview page ${job.page} (${job.edition}) returned HTTP ${response.status}`
          );
        }

        return response.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);

        cache.set(job.key, {
          status: "ready",
          url,
          error: null,
        });
      })
      .catch((error) => {
        cache.set(job.key, {
          status: "error",
          url: null,
          error,
        });
      })
      .finally(() => {
        activeCount -= 1;
        pump();
      });
  }
}

export function preparePreview(edition = "english") {
  const normalizedEdition = normalizeEdition(edition);
  const limit = LIMITS[normalizedEdition];

  for (let page = 1; page <= limit; page += 1) {
    enqueue(normalizedEdition, page);
  }
}

export function getPreparedPreviewImage(edition, page) {
  if (!isAllowedPage(edition, page)) {
    return null;
  }

  const item = cache.get(keyFor(edition, page));

  return item && item.status === "ready" ? item.url : null;
}

export function getPreviewImageStatus(edition, page) {
  if (!isAllowedPage(edition, page)) {
    return "blocked";
  }

  const item = cache.get(keyFor(edition, page));

  return item ? item.status : "missing";
}

export function getPreviewImageLimits(edition) {
  const normalizedEdition = normalizeEdition(edition);
  return LIMITS[normalizedEdition];
}